import React from "react";
import * as Styled from "./styles";
import { ASSETS } from "../../utils/config";
import useScreenSize from "../../hooks/useScreenSize";
import TextView from "../TextView";

const AuthWrapper = ({ children, style, title }) => {
  const { isMobilePortrait, isTabletPortrait, isMobileLandscape } =
    useScreenSize();

  const isMobile = isMobileLandscape || isMobilePortrait || isTabletPortrait;
  return (
    <Styled.Container>
      <Styled.LeftView style={style}>
        {/* {isMobilePortrait || isTabletPortrait ? (
          <Styled.MobileImage
            isTablet={isTabletPortrait}
            src={
              isMobilePortrait
                ? ASSETS.LoginPortrait
                : isTabletPortrait
                ? ASSETS.LoginTablet
                : null
            }
          />
        ) : null} */}

        <Styled.ContentView>
          <Styled.LogoView>
            <Styled.Logo src={ASSETS.iyugaBetaLogo} />
          </Styled.LogoView>
          <TextView
            variant="title"
            style={{ marginBottom: 40, marginTop: 40, textAlign: "center" }}
          >
            {title}
          </TextView>
          {children}
        </Styled.ContentView>
        {/* {isMobile &&  <Styled.Overlay/>} */}
      </Styled.LeftView>
      <Styled.RightView>
        <Styled.IyugaImage src={ASSETS.signup_rightimg} />
      </Styled.RightView>
    </Styled.Container>
  );
};

export default AuthWrapper;
